<template>
  <donut-page-sections-one-column :title="`Recognition ${pointsNoun}`">
    <div class="t dark-gray">
      <span>
        Give and receive peer-to-peer recognition {{ pointsNoun }} with {{ $i18n.t('shoutouts.feature') }},&#32;
        or earn them for Donut participation and achievement.&#32;
      </span>
      <a href="https://help.donut.ai/en/articles/11368486-donut-shoutouts-points-best-practices" class="link ul" target="_blank">Learn more</a>
      <span>.</span><br><br>
      <span v-emoji="`Your ${pointsNoun} emoji is :${emoji}:.`" /><br><br>
      <span>Tag a teammate and use the </span>
      <span v-emoji="`:${config.emoji}:`" />
      <span>
        (:{{ config.emoji }}:) emoji in any Slack channel where you use Donut. Donut will detect a&#32;
        {{ $i18n.t('shoutouts.shoutout', { count: 1 }) }} and distribute {{ pointsNoun }}.
      </span>
    </div>
    <points-slack-previews-channel-shoutout-message class="w-x50 m-tx2" />
    <donut-button type="link" href="/points/config" class="m-tx2">Customize {{ pointsNoun }}</donut-button>
  </donut-page-sections-one-column>
</template>

<script setup>
  import { computed, inject } from 'vue';
  import { useStore } from 'vuex';

  const $i18n = inject('$i18n');
  const { state } = useStore();

  const config = computed(() => state.pointsConfig.config);
  const pointsNoun = $i18n.t('shoutouts.point', { count: 2 });
  const { emoji } = config.value;
</script>
